/**
 * licenseApi.ts (portail client) - wrapper pour /api/license/*
 */
import { apiFetch } from './apiClient';

export interface ClientLicenseStatus {
  hasLicense:    boolean;
  valid:         boolean;
  expired:       boolean;
  revoked?:      boolean;       // true si l admin a revoque la cle
  revokedAt?:    string | null;
  mode?:         'trial' | 'paid';
  plan?:         'starter' | 'pro' | 'business' | 'enterprise';
  validFrom?:    string;
  validUntil?:   string;
  daysRemaining?: number;
  customer?:     { companyName: string; email: string } | string;
  activatedAt?:  string;
  activatedBy?:  string;
  key?:          string;
  message?:      string | null;
  trialLimits?: {
    visibleControls: number;
    blurredDetails:  boolean;
    exportDisabled:  boolean;
    supportLimited:  boolean;
  };
}

export interface RemoveLicenseResponse {
  removed:         boolean;
  previousKey?:    string;
  licenseReleased?: boolean;
  mode?:           'trial';
  message:         string;
}

export const clientLicenseApi = {
  status:   ()              => apiFetch<ClientLicenseStatus>('/license/status'),
  activate: (key: string)   => apiFetch<ClientLicenseStatus>('/license/activate', {
    method: 'POST',
    body:   JSON.stringify({ key }),
  }),
  /** Retire la licence active et libere la cle (sauf si releaseLicense=false). */
  remove:   (opts?: { releaseLicense?: boolean }) =>
    apiFetch<RemoveLicenseResponse>('/license/remove', {
      method: 'POST',
      body:   JSON.stringify(opts ?? {}),
    }),
};
